import React from "react";
import "./leftNavigation.css";
import {
  Menu,
  Divider,
  Button,
  // Dropdown
  Dropdown,
} from "antd";
import { withRouter } from "react-router";
import { Link, useHistory } from "react-router-dom";
import {
  hasAccess,
  isSettings,
  roleCCMapping,
  roleRouteMapping,
  RouteConstants,
} from "../../utils";
import { Local_Variables } from "../../actions/auth";
import {
  useDispatch,
  useSelector,
  //  useSelector
} from "react-redux";
import DashboardIcon from "../../assets/icons/dashboard_icon.svg";
import AdvancesIcon from "../../assets/icons/advances_icon.svg";
import AnalyticsIcon from "../../assets/icons/analytics.svg";
import TransfersIcon from "../../assets/icons/transfers.svg";
import PoliciesIcon from "../../assets/icons/policies.svg";
import AccountIcon from "../../assets/icons/account.svg";
import ReportIcon from "../../assets/icons/report_icon.svg";
import SettingIcon from "../../assets/icons/setting_icon.svg";
import CardIcon from "../../assets/icons/card32.svg";
import TripsIcon from "../../assets/icons/trips_icon.svg";
import ActivityIcon from "../../assets/icons/activity.svg";
import useWindowDimensions from "./../useWindowDimensions";

// import { CaretDownOutlined } from "@ant-design/icons";

// const is_admin = sessionStorage.getItem("is_admin");

const { SubMenu } = Menu;
const LeftNavigation = (props) => {
  // const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [collapsed, setCollapsed] = React.useState(false);
  const [openKeys, setOpenKeys] = React.useState([]);
  const [navWidth, setnavWidth] = React.useState(220);
  const [activeMenu, setActiveMenu] = React.useState(["1"]);
  const { width } = useWindowDimensions();
  const dispatch = useDispatch();
  const is_admin = useSelector(
    (state) => state?.auth?.localVariables?.is_admin
  );
  const url = window.location.href;

  const rootSubmenuKeys = ["sub1", "sub2", "sub3"];
  const history = useHistory();

  React.useEffect(() => {
    const adimin_user = {
      "/dashboard": ["1"],
      "report/": ["2"],
      "/trips/": ["3"],
      "/advances/": ["4"],
      "expenses/": ["5"],
      "/analytics/expenses": ["199"],
      "/setting/": ["21"],
      "/policies/": ["22"],
      "/activity": ["29"],
      "/beneficiary": ["30"],
      "/cards/": ["12"],
      "/card-transactions/": ["13"],
      "/card-inventory/": ["131"],
      "/transfers/quick-transfers/": ["14"],
      "/transfers/bulk-transfers/": ["15"],
      "/transfers/transfers-log/": ["16"],
      "/account/": ["18"],
      "/account-transaction/": ["19"],
      "/checker/users": ["40"],
      "/checker/transfers": ["41"],
      "/checker/user-logs": ["42"],
    };

    const normal_user = {
      "/dashboard": ["1"],
      "/expenses/": ["5"],
      "/reports/": ["6"],
      "/trips/": ["7"],
      "/advances/": ["8"],
      "/cards/": ["12"],
      "/beneficiary": ["30"],
      "/policies/": ["22"],
      "/disputes": ["28"],
      "/activity": ["29"],
    };

    // Dynamically select the menu map
    const menuMap = is_admin ? adimin_user : normal_user;

    // Utility function to determine open keys
    const getOpenKeys = (url) => {
      if (url.includes("/account/") || url.includes("/account-transaction/"))
        return ["sub3"];
      if (url.includes("/transfers/")) return ["sub2"];
      if (url.includes("/cards/")) return ["sub1"];
      return [];
    };

    // Set the open keys based on the current URL
    setOpenKeys(getOpenKeys(url));

    // Determine and set the active menu item
    const activeMenu = Object.keys(menuMap).find((key) => url.includes(key));
    if (activeMenu) {
      setActiveMenu(menuMap[activeMenu]);
    }
  }, [url, is_admin]);

  const navigateToPage = (route) => {
    props.history.push(`${RouteConstants[route]}`);
    switch (route) {
      case "CARDS":
        setActiveMenu(["12"]);
        break;
      case "QUICK_TRANSFERS":
        setActiveMenu(["14"]);
        break;
      case "ACCOUNT":
        setActiveMenu(["18"]);
        break;
      default:
    }
  };
  // console.log(activeMenu);

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);

    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  const handleMenuClick = (evt) => {
    setActiveMenu(evt.keyPath);
  };

  const switchRole = (role) => {
    const menu = JSON.parse(sessionStorage.getItem("menu"));

    if (role.key === "1") {
      sessionStorage.setItem("is_admin", "corporate");
      dispatch({
        type: Local_Variables,
        payload: {
          is_admin: "corporate",
        },
      });
      history.push(
        roleCCMapping[
        Object.keys(menu)?.filter((ele) => ele?.includes("cc_"))?.[0]
        ]
      );
      return;
    } else if (role.key === "2") {
      sessionStorage.setItem("is_admin", true);
      dispatch({
        type: Local_Variables,
        payload: {
          is_admin: true,
        },
      });
    } else {
      sessionStorage.setItem("is_admin", false);
      dispatch({
        type: Local_Variables,
        payload: {
          is_admin: false,
        },
      });
    }

    if (Object.keys(menu).includes("dashboard") || is_admin === true) {
      history.push("/dashboard");
      setActiveMenu(["1"]);
    } else {
      history.push(roleRouteMapping[Object.keys(menu)?.[0]]);
    }
  };

  return (
    <div
      style={{ maxWidth: navWidth, width: "100%" }}
      className="scroll left-navigation-setion"
    >
      <Menu
        selectedKeys={activeMenu}
        mode="inline"
        inlineCollapsed={collapsed}
        className="navigation-div"
        onClick={(evt) => handleMenuClick(evt)}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
      >
        {is_admin === "corporate"
          ? null
          : (hasAccess("dashboard", "read") ||
            hasAccess("dashboard", "write")) && (
            <Menu.Item
              key="1"
              icon={
                <img src={DashboardIcon} alt={"logo"} className="menu-logo" />
              }
              className="menu-list"
            >
              <Link to={RouteConstants.DASHBOARD}>Dashboard</Link>
            </Menu.Item>
          )}
        {is_admin === true || is_admin === "true" ? (
          <>
            {hasAccess("expense_reports", "read") && (
              <Menu.Item
                key="2"
                icon={
                  <img src={ReportIcon} alt={"logo"} className="menu-logo" />
                }
              >
                <Link to={RouteConstants.REPORTS}> Reports</Link>
              </Menu.Item>
            )}
            {hasAccess("trips", "read") && (
              <Menu.Item
                key="3"
                icon={
                  <img src={TripsIcon} alt={"logo"} className="menu-logo" />
                }
              >
                <Link to={RouteConstants.TRIPS}> Trips</Link>
              </Menu.Item>
            )}
            {hasAccess("advances", "read") && (
              <Menu.Item
                key="4"
                icon={
                  <img src={AdvancesIcon} alt={"logo"} className="menu-logo" />
                }
              >
                <Link to={RouteConstants.ADVANCES}>Advances</Link>
              </Menu.Item>
            )}
            <Divider />
          </>
        ) : is_admin === "corporate" ? null : (
          <>
            {/* <p className="userText">COMPANY</p> */}
            {hasAccess("expenses", "read") && (
              <Menu.Item
                key="5"
                icon={
                  <img src={ReportIcon} alt={"logo"} className="menu-logo" />
                }
              >
                <Link to={RouteConstants.EXPENSES}> Expenses</Link>
              </Menu.Item>
            )}
            {hasAccess("expense_reports", "read") && (
              <Menu.Item
                key="6"
                icon={
                  <img src={ReportIcon} alt={"logo"} className="menu-logo" />
                }
              >
                <Link to={RouteConstants.REPORTS}> Reports</Link>
              </Menu.Item>
            )}
            {hasAccess("trips", "read") && (
              <Menu.Item
                key="7"
                icon={
                  <img src={TripsIcon} alt={"logo"} className="menu-logo" />
                }
              >
                <Link to={RouteConstants.TRIPS}> Trips</Link>
              </Menu.Item>
            )}
            {hasAccess("advances", "read") && (
              <Menu.Item
                key="8"
                icon={
                  <img src={AdvancesIcon} alt={"logo"} className="menu-logo" />
                }
              >
                <Link to={RouteConstants.ADVANCES}>Advances</Link>
              </Menu.Item>
            )}
            {/* <Divider /> */}
          </>
        )}
        {/* <p className="userText">COMPANY</p> */}
        {is_admin === true || is_admin === "true" ? (
          <>
            {/* <Divider /> */}
            {(hasAccess("cards", "read") ||
              hasAccess("transactions", "read")) && (
                <SubMenu
                  key="sub1"
                  icon={<img src={CardIcon} alt={"logo"} className="menu-logo" />}
                  title="Cards"
                  onTitleClick={() => navigateToPage("CARDS")}
                >
                  <Menu.Item key="12">
                    <Link to={RouteConstants.CARDS}>Employees</Link>
                  </Menu.Item>
                  {/* {hasAccess("transactions", "read") && (
                    <Menu.Item key="13">
                      <Link to={RouteConstants.CARD_TRANSACTIONS}>
                        Transactions
                      </Link>
                    </Menu.Item>
                  )} */}
                  {sessionStorage.getItem("is_admin") === "true" && (
                    <Menu.Item key="131">
                      <Link to={RouteConstants.CARD_INVENTORY}>Inventory</Link>
                    </Menu.Item>
                  )}
                </SubMenu>
              )}
          </>
        ) : is_admin === "corporate" ? null : (
          hasAccess("cards", "read") && (
            <Menu.Item
              key="12"
              icon={<img src={CardIcon} alt={"logo"} className="menu-logo" />}
            >
              <Link to={RouteConstants.CARDS}>My Cards</Link>
            </Menu.Item>
          )
        )}
        {is_admin === true || is_admin === "true" ? (
          <>
            {hasAccess("transfers", "read") && (
              <SubMenu
                key="sub2"
                icon={
                  <img src={TransfersIcon} alt={"logo"} className="menu-logo" />
                }
                title="Transfers"
                onTitleClick={() => navigateToPage("QUICK_TRANSFERS")}
              >
                <Menu.Item key="14">
                  <Link to={RouteConstants.QUICK_TRANSFERS}>
                    Quick Transfers
                  </Link>
                </Menu.Item>
                {hasAccess("transfers", "write") && (
                  <Menu.Item key="15">
                    <Link to={RouteConstants.BULK_TRANSFERS}>
                      Bulk Transfers
                    </Link>
                  </Menu.Item>
                )}
                <Menu.Item key="16">
                  <Link to={RouteConstants.TRANSFERS_LOG}>Transfers Log</Link>
                </Menu.Item>
                {/* <Menu.Item key="17">
              <Link to={RouteConstants.TRANSFERS_REPORTS}>Transfers Reports</Link>
            </Menu.Item> */}
              </SubMenu>
            )}
            {hasAccess("account", "read") && (
              <SubMenu
                key="sub3"
                icon={
                  <img src={AccountIcon} alt={"logo"} className="menu-logo" />
                }
                title="Account"
                onTitleClick={() => navigateToPage("ACCOUNT")}
              >
                <Menu.Item key="18">
                  <Link to={RouteConstants.ACCOUNT}>Account</Link>
                </Menu.Item>
                <Menu.Item key="19">
                  <Link to={RouteConstants.ACCOUNT_TRANSACTIONS}>
                    Transactions
                  </Link>
                </Menu.Item>
              </SubMenu>
            )}
          </>
        ) : null}
        {/* {is_admin === true ||
        is_admin === "true" ||
        is_admin === "corporate" ? null : (
          <Menu.Item
            key="30"
            icon={<img src={PoliciesIcon} alt={"logo"} className="menu-logo" />}
          >
            <Link to={"/beneficiary"}> Beneficiary</Link>
          </Menu.Item>
        )} */}
        {/* <Menu.Item key="20" icon={<img src={SettingIcon} alt={"logo"} className="menu-logo" />}>
            Analytics
          </Menu.Item> */}
        {hasAccess("analytics", "read") &&
          sessionStorage.getItem("is_admin") === "true" && (
            <Menu.Item
              key="199"
              icon={
                <img src={AnalyticsIcon} alt={"logo"} className="menu-logo" />
              }
            >
              <Link to={RouteConstants.ANALYTICS}>MIS Reports</Link>
            </Menu.Item>
          )}
        {is_admin === "corporate" && hasAccess("cc_user_approvals", "read") ? (
          <Menu.Item
            key="40"
            icon={<img src={PoliciesIcon} alt={"logo"} className="menu-logo" />}
          >
            <Link to={"/checker/users"}> Users</Link>
          </Menu.Item>
        ) : null}

        {is_admin === "corporate" &&
          // hasAccess("cc_transfer_approvals", "read") ? (
          //   <Menu.Item
          //     key="41"
          //     icon={<img src={PoliciesIcon} alt={"logo"} className="menu-logo" />}
          //   >
          //     <Link to={"/checker/transfers"}> Transfers</Link>
          //   </Menu.Item>
          // ) : null}
          hasAccess("cc_transfer_approvals", "read") ? (
          <Menu.Item
            key="41"
            icon={<img src={PoliciesIcon} alt={"logo"} className="menu-logo" />}
          >
            <Link to={RouteConstants.CHECKER_TRANSFERS}> Transfers</Link>
          </Menu.Item>
        ) : null}
        {is_admin === "corporate" && hasAccess("cc_transfer_logs", "read") ? (
          <Menu.Item
            key="16"
            icon={<img src={PoliciesIcon} alt={"logo"} className="menu-logo" />}
          >
            <Link to={RouteConstants.TRANSFERS_LOG}>Transfer Logs</Link>
          </Menu.Item>
        ) : null}
        {is_admin === "corporate" && hasAccess("cc_user_logs", "read") ? (
          <Menu.Item
            key="42"
            icon={<img src={PoliciesIcon} alt={"logo"} className="menu-logo" />}
          >
            <Link to={RouteConstants.USER_LOGS}>User Logs</Link>
          </Menu.Item>
        ) : null}
        <Menu.Item
          key="22"
          icon={<img src={PoliciesIcon} alt={"logo"} className="menu-logo" />}
        >
          <Link to={RouteConstants.POLICIES}> Policies</Link>
        </Menu.Item>
        {is_admin === true ||
          is_admin === "true" ||
          is_admin === "corporate" ? null : (
          <Menu.Item
            key="28"
            icon={<img src={PoliciesIcon} alt={"logo"} className="menu-logo" />}
          >
            <Link to={"/disputes"}> Disputes</Link>
          </Menu.Item>
        )}

        <Menu.Item
          key="29"
          icon={<img src={ActivityIcon} alt={"logo"} className="menu-logo" />}
        >
          <Link to={"/activity"}> Activity</Link>
        </Menu.Item>
        {(is_admin === true || is_admin === "true") && isSettings() ? (
          <Menu.Item
            key="21"
            icon={<img src={SettingIcon} alt={"logo"} className="menu-logo" />}
          >
            <Link to={RouteConstants.SETTINGS}>
              {" "}
              {is_admin === true || is_admin === "true"
                ? "Settings"
                : "My Settings"}
            </Link>
          </Menu.Item>
        ) : null}
        {!collapsed &&
          (sessionStorage.getItem("is_corporate_checker")?.includes("true") ||
            sessionStorage.getItem("is_Admin") === "true") ? (
          <Dropdown
            overlay={
              <Menu onClick={switchRole}>
                {sessionStorage
                  .getItem("is_corporate_checker")
                  ?.includes("true") && (
                    <Menu.Item key="1">Corporate Checker</Menu.Item>
                  )}
                {sessionStorage.getItem("is_Admin") === "true" && (
                  <Menu.Item key="2">Admin</Menu.Item>
                )}
                {sessionStorage.getItem("role")?.includes("Employee") && (
                  <Menu.Item key="3">User</Menu.Item>
                )}
              </Menu>
            }
            placement="top"
          >
            <Button
              type="default"
              ghost
              className="navButton mt1"
            // onClick={switchRole}
            >
              <img src={ReportIcon} alt={"logo"} className="menu-logo" />
              Switched to{" "}
              {is_admin === true || is_admin === "true"
                ? "Admin"
                : is_admin === "corporate"
                  ? "Checker"
                  : "User"}
            </Button>
          </Dropdown>
        ) : null}
      </Menu>
    </div>
  );
};

export default withRouter(LeftNavigation);
